import axios from "axios";

export default class RedirectPagamentoService{

    sendEsitoPagamento(param,onSuccess,onError){
        let host = process.env.REACT_APP_API_URL;
        const configHeaders = {
            headers: {
              "Content-Type": "application/json",
              "Access-Control-Allow-Origin": "*",
              "Access-Control-Allow-Headers":
                "Origin, X-Requested-With, Content-Type, Accept",
              "Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,PATCH,OPTIONS",
            },
          };

          axios
            .get(host + `/public/api/v1/payment/getEsito?identificativo=${param}`,configHeaders)
            .then(
                function (result){
                    if(result.status === 200){
                        onSuccess(result.data)
                    }else{
                        onError()
                    }
                },
                function(error){
                    onError()
                }
            )

    }

    downloadPDF(numeroRicevuta,onSuccess,onError){
        let host = process.env.REACT_APP_API_URL;
        const configHeaders = {
            headers: {
              "Content-Type": "application/json",
              "Access-Control-Allow-Origin": "*",
              "Access-Control-Allow-Headers":
                "Origin, X-Requested-With, Content-Type, Accept",
              "Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,PATCH,OPTIONS",
            },
          };

          axios
            .get(host + `/api/chiamatadierrore/${numeroRicevuta}`,configHeaders)
            .then(
                function (result){
                    if(result.status === 200){
                        onSuccess(result.data)
                    }else{
                        onError()
                    }
                },
                function(error){
                    onError()
                }
            )

    }
}